import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("IronLog render error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0D0E11] flex items-center justify-center p-6">
          <div className="card p-10 max-w-md text-center" data-testid="error-boundary">
            <h1 className="font-head font-900 text-4xl uppercase tracking-tight text-[#FFB800]">Something broke</h1>
            <p className="font-body text-[#94A3B8] mt-3">This screen hit an error. Try reloading — your data is safe.</p>
            <button onClick={() => window.location.reload()} className="btn-signal h-12 px-6 font-head mt-6" data-testid="error-reload">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
